import React from "react";
import { Container } from "reactstrap";
import AppBreadcrumb from "../../Components/Common/AppBreadcrumb";
import AdminHeader from "./components/AdminHeader";
import AdminModules from "./components/AdminModules";
import AuditLog from "./components/AuditLog";

const AdminPage = () => (
  <React.Fragment>
    <div className="page-content">
      <Container fluid>
        <AppBreadcrumb />
        <AdminHeader />
        <AdminModules />
        <AuditLog />
      </Container>
    </div>
  </React.Fragment>
);

export default AdminPage;
